@if ($items().length) {
  <w-kanban class="display-card" [swimlanes]="$swimlanes()" [selectedItem]="$selectedItem()" [editorType]="KanbanEditorType.Internal" [showHeader]="false" [itemKey]="$itemKey()" emptyMessage="No cards" (itemSelected)="onItemSelected($event)" (itemDblClicked)="onItemDblClicked($event)">
    <ng-template itemTemplate let-item="item">
      <entity-card [attr.data-board-row-id]="$itemKey()(item)" [item]="item" [metadata]="$metadata()" [card]="$cardConfig()" [selected]="isSelected(item)" />
    </ng-template>
  </w-kanban>
} @else {
  <board-empty class="is-fill" />
}
